<template>
    <div>
        <div class="card-body">
            <el-form :label-position="'right'"
                     label-width="80px">
                <el-form-item label="兑换人:">
                    {{$parentInfo.dialog_AddReferrerExchangePresent.referrer.name}}
                </el-form-item>
                <el-form-item label="选择活动:">
                    <el-select v-model="activity_id" placeholder="请选择" @change="changeActivity()">
                        <el-option
                                v-for="item in $parentInfo.dialog_AddReferrerExchangePresent.activities"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <div v-if="$parentInfo.dialog_AddReferrerExchangePresent.presents.length!=0">
                    <el-form-item label="选择礼品:">
                        <el-select v-model="present_id" placeholder="请选择">
                            <el-option
                                    v-for="item in $parentInfo.dialog_AddReferrerExchangePresent.presents"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">兑换{{ item.number_type }}人</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <el-form-item label="是否折现:">
                    <el-checkbox v-model="discount" border>折现</el-checkbox>
                </el-form-item>
            </el-form>
        </div>
        <div class="text-right">
            <el-button type="primary" @click="handleStoreExchangePresent"
                       :loading="$parentInfo.dialog_AddReferrerExchangePresent.button_loading">提交兑换礼品
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_AddReferrerExchangePresent",
        data() {
            return {
                activity_id: '',
                present_id: '',
                discount: '0',
            };
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleCreate();
        },
        methods: {
            changeActivity() {
                this.handleCreate();
            },
            handleCreate() {
                this.$wApi.send(this.$parentInfo.path, 'get_giftInfo', {
                    'id': this.$store.state.modal.data.id,
                    'activity_id': this.activity_id,
                });
            },
            handleStoreExchangePresent() {
                this.$parentInfo.dialog_AddReferrerExchangePresent.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'store_exchangePresent', {
                    'activity_id': this.activity_id,
                    'referrer_id': this.$store.state.modal.data.id,
                    'present_id': this.present_id,
                    'discount': this.discount ? 1 : 0,
                    'employee_id': this.$store.state.modal.data.employee_id,
                });
                // this.$axios.post(store.state.server + '/referrer/referrer' + '?' + localStorage.baseUrl + '&activity_id=' + this.activity_id + '&referrer_id=' + this.$route.params.id + '&present_id=' + this.present_id
                //     + '&discount=' + this.discount).then((response) => {
                //     if (response.data.status == 'success') {
                //         this.$message({
                //             message: '兑换成功',
                //             type: 'success'
                //         });
                //         this.closeModal();
                //     }
                // })
            },
        }
    }
</script>

<style scoped>

</style>